document.addEventListener('DOMContentLoaded', function () {
  const topbar = document.querySelector('.fs-topbar');
  const header = document.getElementById('HeaderWrapper');
  const main =
    document.getElementById('MainContent') ||
    document.querySelector('.main-content') ||
    document.querySelector('main[role="main"]');

  if (!topbar && !header) return;

  let lastY = window.scrollY;
  let ticking = false;

  function px(value) {
    return `${Math.round(value)}px`;
  }

  function getOuterHeight(el) {
    return el ? el.offsetHeight || 0 : 0;
  }

  function setOffsets() {
    const topbarHeight = getOuterHeight(topbar);
    const headerHeight = getOuterHeight(header);

    document.documentElement.style.setProperty('--fs-topbar-height', px(topbarHeight));
    document.documentElement.style.setProperty('--motion-header-height', px(headerHeight));

    if (main) {
      main.style.paddingTop = `${topbarHeight + headerHeight}px`;
    }
  }

  function showAll() {
    if (topbar) topbar.classList.remove('is-hidden');
    if (header) header.classList.remove('is-hidden');
  }

  function hideAll() {
    if (topbar) topbar.classList.add('is-hidden');
    if (header) header.classList.add('is-hidden');
  }

  function update() {
    const currentY = window.scrollY;
    const delta = currentY - lastY;
    const tolerance = 4;
    const startHideAfter = 80;

    document.body.classList.toggle('is-at-top', currentY <= 10);

    if (currentY <= 10) {
      showAll();
      lastY = currentY;
      ticking = false;
      return;
    }

    if (Math.abs(delta) < tolerance) {
      ticking = false;
      return;
    }

    if (delta > 0 && currentY > startHideAfter) {
      hideAll();
    } else if (delta < 0) {
      showAll();
    }

    lastY = currentY;
    ticking = false;
  }

  setOffsets();
  showAll();
  document.body.classList.toggle('is-at-top', window.scrollY <= 10);

  window.addEventListener('resize', setOffsets);
  window.addEventListener('load', setOffsets);

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );
});